import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const USER_INITIAL = {
  id: null,
  username: "",
  email: "",
  isAdmin: false,
};

const userSlice = createSlice({
  name: "user",
  initialState: {
    ...USER_INITIAL,
  },
  reducers: {
    USER_UPDATE: (
      state,
      action: PayloadAction<{
        data?: any;
        prop?: string;
        value?: string | boolean;
      }>,
    ) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? { [action.payload.prop]: action.payload.value } : null),
      });
    },
  },
});

const { USER_UPDATE } = userSlice.actions;

export { userSlice, USER_INITIAL, USER_UPDATE };
